import { NavLink } from "react-router-dom"
import PropTypes from "prop-types"
import classNames from "classnames"
import { useSaveContextPreferences } from "hooks/preferences"

function SubLink({ id, parentId, to, label }) {
  const saveLastLocationPreference = useSaveContextPreferences(`navigation.${parentId}`)

  function handleLinkClick() {
    saveLastLocationPreference(id)
  }

  return <NavLink onClick={handleLinkClick} to={to} className={({ isActive }) => classNames("mobile-link sub-link", { active: isActive })}>
    <div className="label">{label}</div>
  </NavLink>
}

SubLink.propTypes = {
  id: PropTypes.string.isRequired,
  parentId: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

export default SubLink
